import * as yup from 'yup'
import { EquipmentDetailsSchemaObject } from './EquipmentDetailsSchema'
import { ShipmentSchema } from './ShipmentSchema'
import { ShipperDetailsSchemaObject } from './ShipperDetailsSchema'

export const CreateShipmentSchema = yup.object({
  ...ShipperDetailsSchemaObject,
  ...EquipmentDetailsSchemaObject,
  shipment: ShipmentSchema,
})

export type TCreateShipmentSchema = yup.InferType<typeof CreateShipmentSchema>
